import * as React from "react";
import { useParams } from "@tanstack/react-router";
import { isPracticeUuid } from "../services/navigation.service.ts";
import { usePractice } from "./practice.provider.tsx";

/** Synchronise le cabinet actif avec le paramètre d’URL (dans le routeur uniquement). */
export function PracticeRouteSync() {
  const { practiceUuid } = useParams({ strict: false });
  const { setPractice } = usePractice();

  React.useEffect(() => {
    if (practiceUuid && isPracticeUuid(practiceUuid)) {
      setPractice(practiceUuid);
    }
  }, [practiceUuid, setPractice]);

  return null;
}
